import React, { useState, useEffect } from 'react';
import { Truck, Sparkles, Tag, X, ChevronRight } from 'lucide-react';

const ANNOUNCEMENTS = [
  {
    id: 1,
    icon: Truck,
    text: 'Miễn phí vận chuyển cho đơn hàng từ 1.000.000đ',
    linkText: 'Xem chi tiết',
    linkUrl: '#'
  },
  {
    id: 2,
    icon: Tag,
    text: 'Nhập mã JapanICHIBA 10 giảm ngay 10% cho đơn hàng đầu tiên',
    linkText: 'Dùng mã ngay',
    linkUrl: '#'
  },
  {
    id: 3,
    icon: Sparkles,
    text: 'Bộ sưu tập Thu - Đông 2026 chính thức mở bán',
    linkText: 'Khám phá',
    linkUrl: '#'
  }
];

export default function TopBanner() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // Tự động chuyển thông báo mỗi 4 giây
  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % ANNOUNCEMENTS.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  const current = ANNOUNCEMENTS[currentIndex];
  const Icon = current.icon;

  return (
    <div className="bg-slate-900 text-white text-xs font-medium py-2.5 px-4 relative z-50 border-b border-slate-800 transition-all">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        
        {/* Khoảng trống bên trái để cân bằng với nút đóng ở bên phải */}
        <div className="w-6 hidden sm:block"></div>

        {/* Nội dung thông báo trung tâm */}
        <div className="flex-1 flex items-center justify-center space-x-2 text-center transition-all duration-500">
          <Icon className="w-4 h-4 text-indigo-400 shrink-0" />
          <span className="text-slate-200">{current.text}</span>
          {current.linkText && (
            <a
              href={current.linkUrl}
              className="font-bold text-indigo-400 hover:text-indigo-300 underline underline-offset-2 flex items-center space-x-0.5 ml-1 transition"
            >
              <span>{current.linkText}</span>
              <ChevronRight className="w-3 h-3 inline" />
            </a>
          )}
        </div>

        {/* Nút Đóng Top Banner */}
        <button
          onClick={() => setIsVisible(false)}
          className="text-slate-400 hover:text-white p-1 rounded-lg hover:bg-slate-800 transition shrink-0"
          title="Đóng thông báo"
        >
          <X className="w-4 h-4" />
        </button>

      </div>
    </div>
  );
}